var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { "aria-label": "stronicowanie" } }, [
    _vm.pagination.page_count > 1
      ? _c(
          "ul",
          { staticClass: "c-pagination" },
          [
            _vm.currentPage > 1
              ? [
                  _c("li", { staticClass: "c-pagination__page" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            _vm.currentPage === 2
                              ? "" + _vm.pathname
                              : _vm.createPageLink(_vm.currentPage - 1),
                          "aria-label": "Poprzednia strona"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.setPage(_vm.currentPage - 1)
                          }
                        }
                      },
                      [_c("Chevron", { staticClass: "icon icon--rotate-180" })],
                      1
                    )
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.pages, function(page, key) {
              return _c(
                "li",
                {
                  key: "left-" + page + "-" + key,
                  staticClass: "c-pagination__page"
                },
                [
                  page === "..."
                    ? _c("span", { staticClass: "c-pagination__dots" }, [
                        _vm._v("...")
                      ])
                    : _c("a", {
                        class: { "is-active": page === _vm.currentPage },
                        attrs: {
                          href:
                            page === 1
                              ? "" + _vm.pathname
                              : _vm.createPageLink(page, key),
                          "aria-current":
                            page === _vm.currentPage ? "page" : null,
                          "aria-label":
                            typeof page === "number" ? "strona " + page : null
                        },
                        domProps: { textContent: _vm._s(page) },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.setPage(page, key)
                          }
                        }
                      })
                ]
              )
            }),
            _vm._v(" "),
            _vm.currentPage < _vm.pagination.page_count
              ? [
                  _c("li", { staticClass: "c-pagination__page" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.createPageLink(_vm.currentPage + 1),
                          "aria-label": "Następna strona"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.setPage(_vm.currentPage + 1)
                          }
                        }
                      },
                      [_c("Chevron", { staticClass: "icon" })],
                      1
                    )
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }